var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_material-date-range","data-name":"Icon material-date-range","d":"M12.5,15H9.833v2.667H12.5Zm5.333,0H15.167v2.667h2.667Zm5.333,0H20.5v2.667h2.667Zm2.667-9.333H24.5V3H21.833V5.667H11.167V3H8.5V5.667H7.167A2.655,2.655,0,0,0,4.513,8.333L4.5,27a2.666,2.666,0,0,0,2.667,2.667H25.833A2.675,2.675,0,0,0,28.5,27V8.333A2.675,2.675,0,0,0,25.833,5.667Zm0,21.333H7.167V12.333H25.833Z","transform":"translate(-4.5 -3)"}));
}

Calendar.defaultProps = {"width":"24","height":"26.667","viewBox":"0 0 24 26.667"};

module.exports = Calendar;

Calendar.default = Calendar;
